import patch from './patch';
import { postImage, errFileSizeTooBig, errInvalidImageType } from '../../lib/userApi';
import { toast } from './toast';
import { handleUnexpectedError } from './handleUnexpectedError';

export const setProfilePhoto = input => (dispatch, _getState) => {
  if (input.files && input.files[0]) {
    const reader = new FileReader();

    reader.onload = (e) => {
      dispatch(patch({
        accountForm: { profilePhotoPreview: e.target.result },
      }));
    };

    reader.readAsDataURL(input.files[0]);
  }
};

export const clearProfilePhotoInput = () => {
  const element = document.getElementById('profile_photo_input');
  if (element) element.value = '';
};

export const saveProfilePhoto = (file, t) => async (dispatch, getState) => {
  const filesize = ((file.size / 1024) / 1024).toFixed(4);
  if (filesize > 5) {
    toast(dispatch, getState({
      message: t('File is too big.'),
      style: 'danger',
    }));
    clearProfilePhotoInput();
    return;
  }
  const { auth } = getState();
  try {
    const { body: { url } } = await postImage(file, auth.token);
    dispatch(patch({
      user: { profilePhoto: url },
      accountForm: { profilePhotoPreview: '', profilePhoto: url },
    }));
  } catch (err) {
    if (err.response) {
      if (err.response.body.some(e => e.code === errFileSizeTooBig)) {
        toast({ message: t('File is too big.'), style: 'danger' })(dispatch, getState);
        clearProfilePhotoInput();
        return;
      } else if (err.response.body.some(e => e.code === errInvalidImageType)) {
        toast({ message: t('Invalid image detected.'), style: 'danger' })(dispatch, getState);
        clearProfilePhotoInput();
        return;
      }
    }
    handleUnexpectedError(err);
  }
  clearProfilePhotoInput();
};
